import type { ReactNode } from 'react';
import { DrawerContent } from '@interxfi/design-system/components/dialog/drawer/shared';
import { SuccessCheck } from '@interxfi/design-system/components/illustration/success-check';
import { Typography } from '@interxfi/design-system/components/typography';
import type { FormWizardBaseStep } from './form-wizard-step';

export interface FormWizardSuccessStep extends FormWizardBaseStep {
  kind: 'success';
  message: string;
  cta: ReactNode;
}

export function FormWizardSuccessStepComponent({ cta, message }: FormWizardSuccessStep) {
  return (
    <DrawerContent align="center" gap={7} inlineAlign="center">
      <SuccessCheck align="center" gap={7} inlineAlign="center">
        {message ? (
          <Typography lineHeight="1.625rem" size="1.125rem" variant="heading" weight="bold">
            {message}
          </Typography>
        ) : null}

        {cta}
      </SuccessCheck>
    </DrawerContent>
  );
}
